module.exports = __webpack_public_path__ + "static/media/md-medical.3a0b8f72.svg";